import styled from "@emotion/styled/macro";
import {ExpiredStatus, StyledCell, StyledRemoveIcon} from "../DoctorsModule/doctorStyles";
import IconButton from "@material-ui/core/IconButton";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../Helpers/env";
import {convDate, dateConvert} from "../Utils/ConvertDate";
import {errorMessages, logoutErrorMessage} from "../../Helpers/ErrorMessages";
import {useTheme} from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import {ErrorMessage} from "../Utils/styledComponents";
import Tooltip from "@material-ui/core/Tooltip";
import {AutoCompleteUnControlled} from "../Utils/FormInputs/AutoCompleteInput";
import {DataCell} from "../Utils/Lists/CollapsibleList";
import TextField from "../Utils/FormInputs/TextField";
import {TestDetailsSkeleton} from "./skeleton/RecordResultsSkeleton";


const Expired = styled(ExpiredStatus)({
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: '10px'
})

const RecordConsumables = ({consumables, setConsumables, hospital_test_id, actions, setIsBlocking,submitted,isResolved}) => {
    const [current_batches, setCurrentBatches] = useState([]);
    const [current_idx, setCurrentIdx] = useState(0);
    const [loading, setLoading] = useState('idle')


    /**
     * Fetch the consumables of a test
     */
    useEffect(() => {
        if (!hospital_test_id) {
            return
        }
        setLoading('loading')
        axios.get(`${config.smsUrl}/claboratory/consumables/hospital_test/${hospital_test_id}`).then(res => {
            const data = res.data;
            const dt = !data ? [] : data;
            // const arr = !dt.data ? [] : dt.data;
            const items = dt.map(product => ({
                ...product,
                selected_batch_ids: [{
                    batch_id: '', available_quantity: 0, chosen_quantity: 0, isError: false, isDuplicate: false
                }],
            }));
            setConsumables(items);
            setLoading('success')
        }).catch(err => {
            errorMessages(err, null, actions)
            setLoading('error')
        })
    }, [hospital_test_id]);


    /**
     * add a new row to the batch_ids list for a consumable
     * @param index
     * @param item
     */
    const handleAddBatchRow = (index, item) => {
        let allRows = [...consumables];
        let new_selected_batches = item['selected_batch_ids'];
        new_selected_batches.push({
            batch_id: '',
            available_quantity: 0,
            chosen_quantity: 0,
            isError: false,
            isDuplicate: false,
            isExpired: false
        });
        allRows[index]['selected_batch_ids'] = new_selected_batches;
        setConsumables(allRows);
        setIsBlocking(true)
    };

    /**
     * Remove batch ids
     * @param index
     * @param btch_idx
     * @param item
     */
    const removeBatchRow = (index, btch_idx, item) => {
        let allRows = [...consumables];
        let new_selected_batches = item['selected_batch_ids'];
        new_selected_batches.splice(btch_idx, 1);
        allRows[index]['selected_batch_ids'] = new_selected_batches;
        setConsumables(allRows);
        setIsBlocking(true)
    };

    /**
     * Add expired status to batch
     * @param array
     * @returns {*}
     */
    function addExpirationStatus(array) {
        return array.map(item => {
            const isExpired = convDate(item.expiry_date) <= dateConvert();
            return {...item, isExpired};
        }).filter(item => !item.isExpired);
    }

    /**
     * Retrieve batches per consumable
     * @param idx
     */
    const handleOnClick = (idx) => {
        if (idx !== current_idx) {
            setCurrentIdx(idx);
        }
        const product_id = consumables[idx]['product_id']
        const formData = new FormData();
        formData.append('product_id', product_id);
        formData.append('location', 3);
        axios.post(`${config.smsUrl}/cinventory/get_batch_by_location`, formData).then(res => {
            const resp = res.data;
            const data = !resp ? {} : resp;
            const batches = data.product ? data.product : {};
            const batchArr = batches.product_batches_in_dispatch ? batches.product_batches_in_dispatch : []
            const batchesArr = batchArr.map(item => ({
                ...item,
                quantity: item.quantity ? item.quantity : 0
            })).filter(item => item.quantity > 0).map(item => ({
                ...item,
                value: item.batch_id,
                label: item.batch_id,
                product_id
            }))
            const batch_arr = addExpirationStatus(batchesArr)
            setCurrentBatches(batch_arr);
        }).catch(error => {
            errorMessages(error, null, actions)
        });
        setIsBlocking(true)
    }

    /**
     * Retrieve batches per consumable
     * @param eventTxt
     * @param idx
     */
    const retrieveBatches = (eventTxt, idx) => {
        if (idx !== current_idx) {
            setCurrentIdx(idx);
        }
        const arr = consumables.map((item, index) => {
            if (index === idx) {
                const product_id = item['product_id']
                const formData = new FormData();
                formData.append('product_id', product_id);
                formData.append('location', 3);
                let btches = [];
                axios.post(`${config.smsUrl}/cinventory/get_batch_by_location`, formData).then(res => {
                    const resp = res.data;
                    const data = !resp ? {} : resp;
                    const batches = data.product ? data.product : {};
                    const batchArr = batches.product_batches_in_dispatch ? batches.product_batches_in_dispatch : []
                    const batchesArr = batchArr.map(item => ({
                        ...item,
                        quantity: item.quantity ? item.quantity : 0
                    })).filter(item => item.quantity > 0).map(item => ({
                        ...item,
                        value: item.batch_id,
                        label: item.batch_id,
                        product_id
                    }))
                    const batch_arr = addExpirationStatus(batchesArr)
                    setCurrentBatches(batch_arr);
                }).catch(error => {
                    logoutErrorMessage(error, null, actions)
                });
                return {...item, test_name: eventTxt, batches: btches, isError: false};
            }
            return item
        })
        setConsumables(arr);
        setIsBlocking(true)
    }

    /**
     * Get details of a selected batch
     * @param event
     * @param idx
     * @param btch_idx
     */
    const getBatchDetails = (event, idx, btch_idx) => {
        // get the drugs
        let allRows = [...consumables];

        if (!event.innerText) {
            allRows[idx]['selected_batch_ids'][btch_idx]['batch_id'] = '';
            allRows[idx]['selected_batch_ids'][btch_idx]['available_quantity'] = '';
            allRows[idx]['selected_batch_ids'][btch_idx]['chosen_quantity'] = '';
            return;
        }

        allRows[idx]['selected_batch_ids'][btch_idx]['chosen_quantity'] = ''

        // get the selected batch_ids
        let new_selected_batches = allRows[idx]['selected_batch_ids'];

        const check_dups = new_selected_batches.some((item) => (item['batch_id'] === event.innerText));

        if (check_dups) {
            new_selected_batches[btch_idx]['isDuplicate'] = true;
        } else {
            new_selected_batches[btch_idx]['isDuplicate'] = false;
        }

        new_selected_batches[btch_idx]['isExpired'] = event.isExpired;

        // set the batch_id
        new_selected_batches[btch_idx]['batch_id'] = event.innerText;

        // const product_id = allRows[idx]['alternative_product_id'] ? allRows[idx]['alternative_product_id'] : allRows[idx]['product_id']
        new_selected_batches[btch_idx]['available_quantity'] = event.quantity < 0 ? 0 : event.quantity;
        new_selected_batches[btch_idx]['isBatch'] = false;

        allRows[idx]['selected_batch_ids'] = new_selected_batches;
        setConsumables(allRows);
        setIsBlocking(true)
    }

    const handleChosenBatchQuantity = (event, idx, btch_idx) => {
        const {value} = event.target;
        let allRows = [...consumables];
        allRows[idx]['selected_batch_ids'][btch_idx]['chosen_quantity'] = value;
        let new_btches = allRows[idx]['selected_batch_ids'];

        const selected_product = allRows[idx]['product_id']
        const selected_batch = allRows[idx]['selected_batch_ids'][btch_idx]['batch_id']
        const available_quantity = allRows[idx]['selected_batch_ids'][btch_idx]['available_quantity']
        const product_name = allRows[idx]['medicine_name']

        // calc the total_chosen_quantity
        let new_total_chosen_quantity = 0;
        for (let x = 0; x < new_btches.length; x++) {
            new_total_chosen_quantity += parseInt(new_btches[x].chosen_quantity ? new_btches[x].chosen_quantity : 0);
        }

        allRows[idx]['total_chosen_quantity'] = parseInt(new_total_chosen_quantity);


        let total_quantity_to_dispense = allRows.filter(item => item.product_id === selected_product &&
            item.selected_batch_ids.every(bat => bat.batch_id !== '' && bat.batch_id === selected_batch)).reduce((prev, curr) => +prev + +curr.total_chosen_quantity, 0)

        allRows[idx]['isCorrectQuantity'] = total_quantity_to_dispense <= available_quantity
        allRows[idx]['alertMessage'] = (
            <span>The quantity input for batch <strong>{selected_batch}</strong> of <strong>{product_name}</strong> exceeds the available stock</span>
        )
        if (total_quantity_to_dispense > available_quantity) {
            allRows[idx]['openAlert'] = true
        } else {
            allRows[idx]['openAlert'] = false
        }

        setConsumables(allRows);
        setIsBlocking(true)
    }

    const handleCloseAlert = (idx) => {
        const arr = consumables.map((item, index) => {
            if (index === idx) {
                return {...item, openAlert: false}
            }
            return item
        })
        setConsumables(arr)
    }


    const theme = useTheme();
    const them = !theme ? {} : theme;
    const palette = !them.palette ? {} : them.palette;



    const headData = [
        {name: 'Consumable', width: 300},
        {name: 'Quantity set', width: 100},
        {
            name: 'Chosen Batch ID(s)',
            width: 300,
            sub_headings: ["Batch ID", "Available Quantity", "Quantity used", "Action"]
        },
        {name: 'Unit', width: 100}];



    const alertRows = consumables.filter(item => !item.isCorrectQuantity)
    const showAlert = consumables.some(item => !item.isCorrectQuantity)

    const alertComponent = (
        showAlert ? alertRows.map((item, idx) => {
            if (item.isCorrectQuantity === false) {
                return (
                    <Alert key={idx} severity="error" style={{paddingTop: 0, paddingBottom: 0, marginBottom: '8px'}}
                           onClose={() => handleCloseAlert(idx)}>
                        {item.alertMessage}
                    </Alert>
                )
            }

        }) : null
    )

    const isLoading = loading === 'loading'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'

    return (
        <div className="mt-4">
            {alertComponent}
            {isLoading ? <TestDetailsSkeleton/>:null}
            {isSuccess ? <table className="table table-bordered table-sm">
                <thead>
                <tr>
                    <td colSpan={headData.length}><strong>Add Consumables</strong></td>
                </tr>
                <tr>
                    {headData.map((item, index) => (
                        item.sub_headings && item.sub_headings.length > 0 ?
                            <td style={{padding: 0}}>
                                <tr style={{display: 'table', width: '100%'}}>
                                    <td  width={item.width ? item.width : 100}
                                        className={palette.type === 'dark' && 'dark-theme-color'}
                                        colSpan={item.sub_headings.length} style={{textAlign: 'center', verticalAlign:'center'}}>
                                        {item.name}
                                    </td>
                                </tr>
                                <tr style={{display: 'table', width: '100%'}}>
                                    {item.sub_headings.map((sub_head) => (
                                        <td className={palette.type === 'dark' && 'dark-theme-color'}>{sub_head}</td>
                                    ))}
                                </tr>
                            </td>
                            :
                            <td width={item.width ? item.width : 100} style={{textAlign: 'center', verticalAlign:'center'}}
                                className={palette.type === 'dark' && 'dark-theme-color'}>{item.name}</td>
                    ))}
                </tr>
                </thead>
                <tbody>
                {consumables.length > 0 ? consumables.map((row, index) => {
                    return (
                        <tr key={index}>
                            <DataCell variant='200' align='center'>
                                {row.product_name}
                            </DataCell>
                            <DataCell variant='100' align='center'>
                                {row.quantity}
                            </DataCell>
                            <DataCell>
                                <table>
                                    <tbody>
                                    {row.selected_batch_ids?.map((btch, btch_idx) => {
                                            const renderOption = option => (
                                                <>
                                                            <span style={{
                                                                display: "inline-block",
                                                                marginRight: '6px'
                                                            }}>{option.label}</span>{option.isExpired ?
                                                    <Expired>Expired</Expired> : null}
                                                </>
                                            )
                                            return (
                                                <tr key={btch_idx}>
                                                    <DataCell variant='150'>
                                                        <AutoCompleteUnControlled options={current_batches}
                                                                                  submitted={submitted}
                                                                                  idx={index}
                                                                                  handleChange={retrieveBatches}
                                                                                  label_text="label"
                                                                                  sub_idx={btch_idx}
                                                                                  onFocus={() => handleOnClick(index)}
                                                                                  medicine_value={{
                                                                                      label: btch.batch_id,
                                                                                      value: btch.batch_id
                                                                                  }} id={`batch_id-${index}`}
                                                                                  value_text="value"
                                                                                  errorMsg_Valid="Please enter a valid batch id"
                                                                                  valid_error_check={btch.isError}
                                                                                  handleProductData={getBatchDetails}
                                                                                  placeholder="Type Batch ID"
                                                                                  errorMsg="Please select a batch ID"
                                                                                  renderOption={renderOption} reset={isResolved}
                                                        />
                                                        {btch.batch_id && btch.isDuplicate && !btch.isExpired &&
                                                            <ErrorMessage>This Batch ID was already
                                                                selected</ErrorMessage>}
                                                        {btch.batch_id && btch.isExpired &&
                                                            <ErrorMessage>This batch is expired</ErrorMessage>}
                                                    </DataCell>
                                                    <DataCell variant='100'>
                                                        {btch.available_quantity}
                                                    </DataCell>
                                                    <DataCell variant='100'>
                                                        <TextField submitted={submitted} type="number"
                                                                   disabled={btch.isExpired}
                                                                   value={btch.chosen_quantity} min="0"
                                                                   id={`quantity-${index}`}
                                                                   onChange={(e) => handleChosenBatchQuantity(e, index, btch_idx)}
                                                                   style={{fontSize: '11px'}}
                                                                   required/>
                                                        {submitted && (!btch.chosen_quantity) &&
                                                            <ErrorMessage>This is a required
                                                                field</ErrorMessage>}
                                                    </DataCell>
                                                    <DataCell>
                                                        <Tooltip title='Remove'>
                                                            <IconButton type='button'
                                                                        onClick={() => removeBatchRow(index, btch_idx, row)}>
                                                                <StyledRemoveIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </DataCell>
                                                </tr>
                                            )
                                        }
                                    )}
                                    <tr>
                                        <StyledCell colSpan="4">
                                            <button type="button"
                                                    onClick={() => handleAddBatchRow(index, row)}
                                                    className="btn btn-sm sms-gray-btn"
                                                    id="add-row">Add another batch
                                            </button>
                                            {submitted && (parseInt(row.total_chosen_quantity) !== parseInt(row.quantity_billed)) &&
                                                <ErrorMessage>Chosen Quantity is not equal to quantity</ErrorMessage>}
                                        </StyledCell>
                                    </tr>
                                    </tbody>
                                </table>
                            </DataCell>
                            <DataCell variant='50' align='center'>
                                {row.unit}
                            </DataCell>
                        </tr>
                    )
                }) : <tr>
                    <td colSpan={headData.length} align="center"
                        className={palette.type === 'dark' && 'dark-theme-color'}>No consumables added to this test</td>
                </tr>}
                </tbody>
            </table>:null}
            {isError ? <p>There was an error loading consumables</p> : null}
        </div>

    )
};

export default RecordConsumables;